import React from 'react';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import About from './components/About';
import Philosophy from './components/Philosophy';
import Services from './components/Services';
import Contact from './components/Contact';
import Footer from './components/Footer';

function App() {
  return (
    <div className="bg-dark-900 min-h-screen text-white selection:bg-gold-500 selection:text-black">
      <Navbar />
      <Hero />
      <About />
      <Philosophy />
      <Services />
      <Contact />
      <Footer />
    </div>
  );
}

export default App;